import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GetPoolsTransformResponse, Paginator, PoolFormatLogo } from 'types'

const START_PAGE = 1
const PAGE_LIMIT = 10

type State = {
  poolsData: Paginator & {
    data: PoolFormatLogo[]
  }
}

const initialState: State = {
  poolsData: {
    count: 0,
    data: [],
    page: START_PAGE,
    pageCount: 0,
    pageLimit: PAGE_LIMIT,
    total: 0,
  },
}

export const sliceFund = createSlice({
  initialState,
  name: 'fund',
  reducers: {
    setFundPoolsData: (state, { payload }: PayloadAction<GetPoolsTransformResponse>) => {
      state.poolsData = { ...state.poolsData, ...payload }
    },
    setFundPoolsPage: (state, { payload }: PayloadAction<number>) => {
      state.poolsData = { ...state.poolsData, page: payload }
    },
    updatePoolStatus: (state, { payload }: PayloadAction<PoolFormatLogo[]>) => {
      const updatedPools = state.poolsData.data.map((pool) => {
        const updatedPool = payload.find((p) => p.id === pool.id)
        return updatedPool ? { ...pool, status: updatedPool.status } : pool
      })
      state.poolsData = { ...state.poolsData, data: updatedPools }
    },
  },
})
export const { setFundPoolsData, setFundPoolsPage, updatePoolStatus } = sliceFund.actions
